/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Uniform product covers ---------------------------------------------------
   Covers use object-fit:cover so every tile is the same shape. That crops, and
   a handful of catalogue images (landscape "bundle" shots of two books side by
   side) lose so much that the crop lands on the white gap between the books and
   the card renders as a blank white tile.

   This flags any image that would lose more than MAX_CROP and lets CSS fall
   back to object-fit:contain for just those. Pairs with the .img-fit-contain
   rule in the PART 4 block of assets/theme.css.

   Measured on this catalogue: 372 products, ~52 fall back to contain.
   --------------------------------------------------------------------------- */
(function () {
  var FRAME_RATIO = 2 / 3;   // the .aspect-ratio box is 2:3
  var MAX_CROP = 0.12;       // 12% - raise to crop more, lower to crop less

  function fit(img) {
    if (!img.naturalWidth || img.dataset.fitChecked) return;
    img.dataset.fitChecked = '1';
    var ar = img.naturalWidth / img.naturalHeight;
    var crop = ar > FRAME_RATIO ? 1 - FRAME_RATIO / ar : 1 - ar / FRAME_RATIO;
    if (crop > MAX_CROP) img.classList.add('img-fit-contain');
  }

  function scan() {
    var imgs = document.querySelectorAll(
      '.product-list .product-item__primary-image, .product-list .product-item__secondary-image'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete) {
        fit(img);
      } else {
        img.addEventListener('load', function () { fit(this); }, { once: true });
      }
    }
  }

  var queued;
  function scanSoon() {
    clearTimeout(queued);
    queued = setTimeout(scan, 100);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);

  // Collection filtering, pagination and the carousels swap cards in via AJAX.
  // childList only - so adding the class below never re-triggers this observer.
  new MutationObserver(scanSoon).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();



/* Product gallery lightbox -------------------------------------------------
   Warehouse ships Drift (data-zoom / data-zoom-width on .product-gallery__image),
   which magnifies a small region under the cursor. That works for inspecting a
   detail, but it is useless for reading a back cover: you get a moving keyhole
   over body text instead of the whole page.

   This adds click-to-open: the image opens full-screen, fit to the viewport,
   with prev/next across the product's images, click-to-zoom-to-100% + drag to
   pan, and pinch/swipe on touch. The theme's hover zoom (Drift) is switched off in
   templates/product*.json, so this binds to every product gallery.

   NOTE ON SOURCE RESOLUTION
   Most covers in this catalogue are uploaded small - median master is ~354px
   wide, and 277 of 341 images are under 600px. The lightbox requests the
   largest size Shopify will serve (2048px), but Shopify never upscales, so a
   333px master opens as 333px stretched to fit. This makes hi-res images
   genuinely readable; it cannot invent detail that was never uploaded.

   Pairs with the lightbox block in assets/theme.css.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GALLERY   = '.product-gallery__carousel';
  var SLIDE     = '.product-gallery__carousel-item[data-media-type="image"]';
  var SRC_WIDTH = 2048;  // Shopify's largest standard transform
  var DRAG_SLOP = 8;     // px of movement that turns a click into a Flickity drag

  var overlay, imgEl, stage, counter, prevBtn, nextBtn;
  var slides = [], index = 0, openedFrom = null;
  var scale = 1, panX = 0, panY = 0, minScale = 1, maxScale = 1;
  var suppressClick = false;

  /* --- helpers ------------------------------------------------------------ */

  // Ask the CDN for a specific width. Shopify won't upscale, so this is a
  // ceiling rather than a resize: small masters come back at their own size.
  function sized(url, w) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    // image_url URLs carry the size as a width= param rather than a filename suffix.
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  // Best available source for a gallery <img>: Drift's data-zoom is the
  // untransformed master, so prefer it over the (already shrunk) src.
  function bestSrc(img) {
    return sized(img.getAttribute('data-zoom') || img.currentSrc || img.src, SRC_WIDTH);
  }

  /* --- overlay construction ----------------------------------------------- */

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pl-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image viewer');
    overlay.innerHTML =
      '<button class="pl-close" type="button" aria-label="Close image viewer">&times;</button>' +
      '<button class="pl-nav pl-nav--prev" type="button" aria-label="Previous image"></button>' +
      '<button class="pl-nav pl-nav--next" type="button" aria-label="Next image"></button>' +
      '<div class="pl-stage"><img class="pl-image" alt=""></div>' +
      '<div class="pl-counter" aria-live="polite"></div>';

    stage   = overlay.querySelector('.pl-stage');
    imgEl   = overlay.querySelector('.pl-image');
    counter = overlay.querySelector('.pl-counter');
    prevBtn = overlay.querySelector('.pl-nav--prev');
    nextBtn = overlay.querySelector('.pl-nav--next');

    overlay.querySelector('.pl-close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    // Backdrop click closes; clicks on the image itself must not bubble up to it.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === stage) close();
    });

    // Click the image to zoom, click the backdrop to close. suppressClick is set
    // by the pan handler so that releasing a drag doesn't also toggle the zoom.
    imgEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (suppressClick) { suppressClick = false; return; }
      toggleZoom(e);
    });
    imgEl.addEventListener('dblclick', function (e) { e.preventDefault(); });

    bindZoomAndPan();
    document.body.appendChild(overlay);
  }

  /* --- zoom + pan ---------------------------------------------------------- */

  function applyTransform() {
    imgEl.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    overlay.classList.toggle('is-zoomed', scale > minScale + 0.01);
  }

  function resetZoom() {
    scale = minScale = 1;
    panX = panY = 0;
    // How far we can zoom before hitting the image's real pixels. Small masters
    // still get a little headroom so the control never feels dead.
    var natural = imgEl.naturalWidth || 1;
    var shown   = imgEl.clientWidth || 1;
    maxScale = Math.max(2, Math.min(6, natural / shown));
    applyTransform();
  }

  // Keep the image from being dragged entirely off-screen.
  function clampPan() {
    var r = imgEl.getBoundingClientRect();
    var overX = Math.max(0, (r.width  - window.innerWidth)  / 2);
    var overY = Math.max(0, (r.height - window.innerHeight) / 2);
    panX = Math.max(-overX, Math.min(overX, panX));
    panY = Math.max(-overY, Math.min(overY, panY));
  }

  function zoomTo(next, originX, originY) {
    next = Math.max(minScale, Math.min(maxScale, next));
    if (next === scale) return;
    // Zoom about the pointer: keep the point under the cursor stationary.
    var r = imgEl.getBoundingClientRect();
    var cx = originX - (r.left + r.width  / 2);
    var cy = originY - (r.top  + r.height / 2);
    var ratio = next / scale;
    panX -= cx * (ratio - 1);
    panY -= cy * (ratio - 1);
    scale = next;
    clampPan();
    applyTransform();
  }

  function toggleZoom(e) {
    if (scale > minScale + 0.01) {
      scale = minScale; panX = panY = 0; applyTransform();
    } else {
      zoomTo(maxScale, e.clientX, e.clientY);
    }
  }

  function bindZoomAndPan() {
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomTo(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY);
    }, { passive: false });

    var dragging = false, lastX = 0, lastY = 0, moved = 0;

    imgEl.addEventListener('pointerdown', function (e) {
      if (scale <= minScale + 0.01) return;   // only pan while zoomed in
      dragging = true; moved = 0;
      lastX = e.clientX; lastY = e.clientY;
      imgEl.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    imgEl.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      panX += e.clientX - lastX;
      panY += e.clientY - lastY;
      moved += Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY);
      lastX = e.clientX; lastY = e.clientY;
      clampPan();
      applyTransform();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (moved > DRAG_SLOP) suppressClick = true;
      try { imgEl.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    imgEl.addEventListener('pointerup', endDrag);
    imgEl.addEventListener('pointercancel', endDrag);

    // Swipe between images when not zoomed (touch only - a mouse drag at scale
    // 1 shouldn't flick the gallery).
    var startX = 0, startY = 0, swiping = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || scale > minScale + 0.01) { swiping = false; return; }
      swiping = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* --- open / navigate / close --------------------------------------------- */

  function show(i) {
    index = (i + slides.length) % slides.length;
    var src = bestSrc(slides[index]);

    overlay.classList.add('is-loading');
    imgEl.style.transform = '';
    imgEl.src = src;
    imgEl.alt = slides[index].alt || '';

    if (imgEl.complete) onLoaded();
    else imgEl.addEventListener('load', onLoaded, { once: true });

    counter.textContent = slides.length > 1 ? (index + 1) + ' / ' + slides.length : '';
    var multi = slides.length > 1;
    prevBtn.hidden = nextBtn.hidden = !multi;
  }

  function onLoaded() {
    overlay.classList.remove('is-loading');
    resetZoom();
  }

  function go(step) {
    if (slides.length > 1) show(index + step);
  }

  function onKey(e) {
    if (e.key === 'Escape')      { close(); }
    else if (e.key === 'ArrowLeft')  { go(-1); }
    else if (e.key === 'ArrowRight') { go(1); }
  }

  function open(gallery, startIndex, trigger) {
    slides = [].slice.call(gallery.querySelectorAll(SLIDE + ' img'));
    if (!slides.length) return;

    openedFrom = trigger || null;
    if (!overlay) build();

    show(startIndex);
    overlay.classList.add('is-open');
    document.documentElement.classList.add('pl-lock');
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.pl-close').focus();
  }

  function close() {
    overlay.classList.remove('is-open', 'is-zoomed');
    document.documentElement.classList.remove('pl-lock');
    document.removeEventListener('keydown', onKey);

    // Leave the on-page gallery showing whatever the shopper ended on.
    try {
      var id = slides[index].closest(SLIDE).getAttribute('data-media-id');
      var thumb = document.querySelector('.product-gallery__thumbnail[data-media-id="' + id + '"]');
      if (thumb) thumb.click();
    } catch (err) {}

    imgEl.removeAttribute('src');
    if (openedFrom && openedFrom.focus) openedFrom.focus();
    openedFrom = null;
  }

  /* --- wiring -------------------------------------------------------------- */

  function bindGallery(gallery) {
    if (gallery.dataset.plBound) return;
    gallery.dataset.plBound = '1';
    gallery.classList.add('pl-enabled');

    // Flickity drags are pointer drags that end in a click. Measure the travel
    // and swallow anything that was really a swipe.
    var downX = 0, downY = 0;
    gallery.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY;
    }, true);

    gallery.addEventListener('click', function (e) {
      var img = e.target.closest(SLIDE + ' img');
      if (!img) return;
      if (Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > DRAG_SLOP) return;

      e.preventDefault();
      e.stopPropagation();

      var imgs = [].slice.call(gallery.querySelectorAll(SLIDE + ' img'));
      open(gallery, imgs.indexOf(img), img);
    });
  }

  function scan() {
    var galleries = document.querySelectorAll(GALLERY);
    for (var i = 0; i < galleries.length; i++) bindGallery(galleries[i]);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);

  // Quick-view modals and section re-renders in the theme editor swap the
  // gallery in after load. childList only, and bindGallery is idempotent.
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
